import {Models} from '@rematch/core';
import {Chats} from './chats';
import {Users} from './users';
import {Messages} from './messages';
import {Auth} from './auth';
import {Main} from './main';
import {DATA} from './data';


export interface RootModel extends Models<RootModel> {
    auth: typeof Auth;
    chats: typeof Chats;
    users: typeof Users;
    messages: typeof Messages;
    main: typeof Main;
    DATA: typeof DATA;
}


export const models: RootModel = {
    auth: Auth,
    chats: Chats,
    users: Users,
    messages: Messages,
    main: Main,
    DATA,
};
